// "use client";

// import React, { useEffect, useState } from "react";
// import {
//   Card,
//   Box,
//   Typography,
//   Table,
//   TableBody,
//   TableCell,
//   TableContainer,
//   TableFooter,
//   TablePagination,
//   TableRow,
//   Paper,
//   IconButton,
//   TableHead,
//   Checkbox,
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   FormControl,
//   InputLabel,
//   Select,
//   MenuItem,
//   DialogActions,
//   Button,
//   TextField,
//   FormLabel,
//   RadioGroup,
//   FormControlLabel,
//   Radio,
// } from "@mui/material";
// import { useTheme } from "@mui/material/styles";
// import KeyboardArrowLeft from "@mui/icons-material/KeyboardArrowLeft";
// import KeyboardArrowRight from "@mui/icons-material/KeyboardArrowRight";
// import AddNewUser from "./AddNewUser";
// import { getAllAdminApi } from "../../../redux/api/api";

// const label = { inputProps: { "aria-label": "Checkbox demo" } };

// function TablePaginationActions(props) {
//   const theme = useTheme();
//   const { count, page, rowsPerPage, onPageChange } = props;

//   const handleBackButtonClick = (event) => {
//     onPageChange(event, page - 1);
//   };

//   const handleNextButtonClick = (event) => {
//     onPageChange(event, page + 1);
//   };

//   return (
//     <Box
//       sx={{
//         flexShrink: 0,
//         display: "flex",
//         gap: "10px",
//         padding: "0 20px",
//       }}
//     >
//       <IconButton
//         onClick={handleBackButtonClick}
//         disabled={page === 0}
//         aria-label="previous page"
//         sx={{
//           borderRadius: "4px",
//           padding: "4px",
//         }}
//         className="border"
//       >
//         {theme.direction === "rtl" ? (
//           <KeyboardArrowRight />
//         ) : (
//           <KeyboardArrowLeft />
//         )}
//       </IconButton>

//       <IconButton
//         onClick={handleNextButtonClick}
//         disabled={page >= Math.ceil(count / rowsPerPage) - 1}
//         aria-label="next page"
//         sx={{
//           borderRadius: "4px",
//           padding: "4px",
//         }}
//         className="border"
//       >
//         {theme.direction === "rtl" ? (
//           <KeyboardArrowLeft />
//         ) : (
//           <KeyboardArrowRight />
//         )}
//       </IconButton>
//     </Box>
//   );
// }

// function createData(id, userImg, userName, email, role, projectAccess, status) {
//   return {
//     id,
//     userImg,
//     userName,
//     email,
//     role,
//     projectAccess,
//     status,
//   };
// }


// const UsersTable = () => {
//   const [searchText, setSearchText] = useState("");
//   const [page, setPage] = useState(0);
//   const [rowsPerPage, setRowsPerPage] = useState(10);
//   const [admins, setAdmins] = useState([]);
//   ////console.log("Admins:", admins);
//   const [open, setOpen] = useState(false);
//   const [selectedAdmin, setSelectedAdmin] = useState(null);

//   const handleChangePage = (event, newPage) => {
//     setPage(newPage);
//   };

//   const handleChangeRowsPerPage = (event) => {
//     setRowsPerPage(parseInt(event.target.value, 10));
//     setPage(0);
//   };

//   const handleSearch = (event) => {
//     setSearchText(event.target.value);
//     setPage(0); // Reset to the first page when a new search is performed
//   };
//   const handleSave = () => {
//     // 🔑 Call your API to update admin status here
//    //console.log("Saving:", selectedAdmin);

//     // Example: await updateAdminApi(selectedAdmin._id, selectedAdmin);
//     setOpen(false);
//   };
//   const handleEditClick = (admin) => {
//     setSelectedAdmin(admin);
//     setOpen(true);
//   };

//   const handleClose = () => {
//     setOpen(false);
//     setSelectedAdmin(null);
//   };

//   const fetchAdmins = async () => {
//     try {
//       const response = await getAllAdminApi();

//       // ✅ Safely filter only admins with category "Events"
//       const eventAdmins = (response.data?.info || []).filter(
//         (admin) => admin.category === "Events"
//       );

//       setAdmins(eventAdmins);
//       console.log("Event Admins:", eventAdmins);
//     } catch (error) {
//       console.error("Error fetching admins:", error);
//     }
//   };



//   useEffect(() => {
//     fetchAdmins();
//   }, []);


//   return (
//     <>
//       <Card
//         sx={{
//           boxShadow: "none",
//           borderRadius: "7px",
//           mb: "25px",
//           padding: { xs: "18px", sm: "20px", lg: "25px" },
//         }}
//         className="rmui-card"
//       >
//         <Box
//           sx={{
//             display: { xs: "block", sm: "flex" },
//             alignItems: "center",
//             justifyContent: "space-between",
//             mb: "25px",
//           }}
//         >
//           <Box
//             component="form"
//             className="t-search-form"
//             sx={{
//               width: { sm: "265px" },
//             }}
//           >
//             <label>
//               <i className="material-symbols-outlined">search</i>
//             </label>
//             <input
//               type="text"
//               className="t-input"
//               placeholder="Search user here..."
//               value={searchText}
//               onChange={handleSearch}
//             />
//           </Box>

//           <AddNewUser />
//         </Box>

//         {/* Table */}
//         <Box
//           sx={{
//             marginLeft: "-25px",
//             marginRight: "-25px",
//           }}
//         >
//           <TableContainer
//             component={Paper}
//             sx={{
//               boxShadow: "none",
//               borderRadius: "0",
//             }}
//             className="rmui-table"
//           >
//             <Table sx={{ minWidth: 1350 }} aria-label="Table">
//               <TableHead className="bg-primary-50">
//                 <TableRow
//                   sx={{
//                     th: {
//                       fontWeight: "500",
//                       padding: "10px 24px",
//                       fontSize: "14px",
//                     },
//                   }}
//                 >
//                   <TableCell className="text-black border-bottom">#</TableCell>

//                   <TableCell className="text-black border-bottom">ID</TableCell>

//                   <TableCell className="text-black border-bottom">
//                     User
//                   </TableCell>

//                   <TableCell className="text-black border-bottom">
//                     Email
//                   </TableCell>

//                   <TableCell className="text-black border-bottom">
//                     Role
//                   </TableCell>

//                   {/* <TableCell className="text-black border-bottom">
//                     Project Access
//                   </TableCell> */}

//                   <TableCell className="text-black border-bottom">
//                     Status
//                   </TableCell>

//                   <TableCell className="text-black border-bottom">
//                     Action
//                   </TableCell>
//                 </TableRow>
//               </TableHead>

//               <TableBody>
//                 {(rowsPerPage > 0
//                   ? admins.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
//                   : admins
//                 ).map((admin, index) => (
//                   <TableRow
//                     key={admin._id}
//                     sx={{
//                       td: {
//                         padding: "15px 20px",
//                         fontSize: "14px",
//                       },
//                     }}
//                   >
//                     {/* Checkbox */}
//                     <TableCell
//                       sx={{ padding: "5px 13px !important", width: "65px" }}
//                       className="border-bottom"
//                     >
//                       <Checkbox {...label} sx={{ padding: "8px" }} />
//                     </TableCell>

//                     {/* ID */}
//                     <TableCell className="border-bottom">
//                       # {admin._id.slice(-4)}
//                     </TableCell>


//                     {/* User (Image + Name) */}
//                     <TableCell className="border-bottom">
//                       <Box sx={{ display: "flex", alignItems: "center", gap: "12px" }}>
//                         {/* <Box sx={{ flexShrink: "0" }}>
//                           <img
//                             src={admin.imageUrl || "/default-avatar.png"} // fallback if no image
//                             alt={admin.firstName}
//                             width={40}
//                             height={40}
//                             style={{ borderRadius: "100px" }}
//                           />
//                         </Box> */}
//                         <Box>
//                           <Typography
//                             sx={{
//                               fontSize: { xs: "14px", lg: "15px" },
//                               fontWeight: "500",
//                             }}
//                             className="text-black"
//                           >
//                             {admin.firstName} {admin.lastName}
//                           </Typography>
//                         </Box>
//                       </Box>
//                     </TableCell>

//                     {/* Email */}
//                     <TableCell className="text-black border-bottom">
//                       {admin.emailId}
//                     </TableCell>

//                     {/* Role */}
//                     <TableCell className="border-bottom">{admin.role || "N/A"}</TableCell>


//                     {/* Status */}
//                     <TableCell className="border-bottom">
//                       <Box
//                         className={`trezo-badge ${admin.status ? "active" : "inactive"}`}
//                         sx={{ textTransform: "capitalize" }}
//                       >
//                         {admin.status ? "Active" : "Pending"}
//                       </Box>
//                     </TableCell>

//                     {/* Actions */}
//                     <TableCell className="border-bottom">
//                       <Box sx={{ display: "flex", alignItems: "center" }}>
//                         <IconButton aria-label="view" color="primary" sx={{ padding: "5px" }}>
//                           <i className="material-symbols-outlined" style={{ fontSize: "16px" }}>
//                             visibility
//                           </i>
//                         </IconButton>

//                         <IconButton
//                           aria-label="edit"
//                           color="secondary"
//                           sx={{ padding: "5px" }}
//                           onClick={() => handleEditClick(admin)}
//                         >
//                           <i
//                             className="material-symbols-outlined"
//                             style={{ fontSize: "16px" }}
//                           >
//                             edit
//                           </i>
//                         </IconButton>

//                         <IconButton aria-label="delete" color="error" sx={{ padding: "5px" }}>
//                           <i className="material-symbols-outlined" style={{ fontSize: "16px" }}>
//                             delete
//                           </i>
//                         </IconButton>
//                       </Box>
//                     </TableCell>
//                   </TableRow>
//                 ))}
//               </TableBody>


//               <TableFooter>
//                 <TableRow>
//                   <TablePagination
//                     rowsPerPageOptions={[
//                       5,
//                       10,
//                       25,
//                       { label: "All", value: -1 },
//                     ]}
//                     colSpan={10}
//                     count={admins.length}
//                     rowsPerPage={rowsPerPage}
//                     page={page}
//                     slotProps={{
//                       select: {
//                         inputProps: {
//                           "aria-label": "rows per page",
//                         },
//                         native: true,
//                       },
//                     }}
//                     onPageChange={handleChangePage}
//                     onRowsPerPageChange={handleChangeRowsPerPage}
//                     ActionsComponent={TablePaginationActions}
//                     sx={{
//                       border: "none",

//                       ".MuiToolbar-root": {
//                         minHeight: "auto",
//                         marginTop: "15px",
//                       },
//                     }}
//                   />
//                 </TableRow>
//               </TableFooter>
//             </Table>
//           </TableContainer>
//         </Box>
//       </Card>
//       <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
//         <DialogTitle>Edit Admin</DialogTitle>
//         <DialogContent dividers>
//           {selectedAdmin && (
//             <>
//               <TextField
//                 margin="dense"
//                 label="First Name"
//                 fullWidth
//                 value={selectedAdmin.firstName}
//                 onChange={(e) =>
//                   setSelectedAdmin({ ...selectedAdmin, firstName: e.target.value })
//                 }
//               />
//               <TextField
//                 margin="dense"
//                 label="Last Name"
//                 fullWidth
//                 value={selectedAdmin.lastName}
//                 onChange={(e) =>
//                   setSelectedAdmin({ ...selectedAdmin, lastName: e.target.value })
//                 }
//               />
//               <TextField
//                 margin="dense"
//                 label="Email"
//                 fullWidth
//                 value={selectedAdmin.emailId}
//                 disabled
//               />

//               <FormLabel component="legend" sx={{ mt: 2 }}>
//                 Status
//               </FormLabel>
//               <RadioGroup
//                 row
//                 value={selectedAdmin.status ? "active" : "inactive"}
//                 onChange={(e) =>
//                   setSelectedAdmin({
//                     ...selectedAdmin,
//                     status: e.target.value === "active",
//                   })
//                 }
//               >
//                 <FormControlLabel value="active" control={<Radio />} label="Active" />
//                 <FormControlLabel
//                   value="inactive"
//                   control={<Radio />}
//                   label="Inactive"
//                 />
//               </RadioGroup>
//             </>
//           )}
//         </DialogContent>
//         <DialogActions>
//           <Button onClick={handleClose}>Cancel</Button>
//           <Button variant="contained" onClick={handleSave}>
//             OK
//           </Button>
//         </DialogActions>
//       </Dialog>
//     </>
//   );
// };

// export default UsersTable;




"use client";

import React, { useEffect, useState } from "react";
import {
  Card,
  Box,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableFooter,
  TablePagination,
  TableRow,
  Paper,
  IconButton,
  TableHead,
  Checkbox,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import KeyboardArrowLeft from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRight from "@mui/icons-material/KeyboardArrowRight";
import AddNewUser from "./AddNewUser";
import { getAllAdminApi } from "../../../redux/api/api";

// ✅ Ant Design imports
import { Modal, Form, Input, Radio, Button } from "antd";

const label = { inputProps: { "aria-label": "Checkbox demo" } };

function TablePaginationActions(props) {
  const theme = useTheme();
  const { count, page, rowsPerPage, onPageChange } = props;

  const handleBackButtonClick = (event) => {
    onPageChange(event, page - 1);
  };

  const handleNextButtonClick = (event) => {
    onPageChange(event, page + 1);
  };

  return (
    <Box
      sx={{
        flexShrink: 0,
        display: "flex",
        gap: "10px",
        padding: "0 20px",
      }}
    >
      <IconButton
        onClick={handleBackButtonClick}
        disabled={page === 0}
        aria-label="previous page"
        sx={{ borderRadius: "4px", padding: "4px" }}
        className="border"
      >
        {theme.direction === "rtl" ? (
          <KeyboardArrowRight />
        ) : (
          <KeyboardArrowLeft />
        )}
      </IconButton>

      <IconButton
        onClick={handleNextButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="next page"
        sx={{ borderRadius: "4px", padding: "4px" }}
        className="border"
      >
        {theme.direction === "rtl" ? (
          <KeyboardArrowLeft />
        ) : (
          <KeyboardArrowRight />
        )}
      </IconButton>
    </Box>
  );
}

const UsersTable = () => {
  const [searchText, setSearchText] = useState("");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [admins, setAdmins] = useState([]);
  const [open, setOpen] = useState(false);
  const [selectedAdmin, setSelectedAdmin] = useState(null);
  const [form] = Form.useForm();

  const handleChangePage = (event, newPage) => setPage(newPage);

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleSearch = (event) => {
    setSearchText(event.target.value);
    setPage(0);
  };

  const handleEditClick = (admin) => {
    setSelectedAdmin(admin);
    setOpen(true);

    // preload form values
    form.setFieldsValue({
      firstName: admin.firstName,
      lastName: admin.lastName,
      emailId: admin.emailId,
      status: admin.status ? "active" : "inactive",
    });
  };


  // const handleSave = async () => {
  //   try {
  //     console.log("Saving:", selectedAdmin);
  //     return
  //     if (!selectedAdmin?._id) return;

  //     const res = await fetch("/api/admin/update-admin", {
  //       method: "POST", // or "PUT" if you want REST style
  //       headers: {
  //         "Content-Type": "application/json",
  //       },
  //       body: JSON.stringify(selectedAdmin), // ✅ send updated admin data
  //     });

  //     const response = await res.json(); // ✅ parse JSON

  //     console.log("Update Response:", response);

  //     if (response.success) {
  //       // ✅ Update UI instantly
  //       setAdmins((prev) =>
  //         prev.map((admin) =>
  //           admin._id === selectedAdmin._id ? response.data : admin
  //         )
  //       );
  //       setOpen(false);
  //     }
  //   } catch (error) {
  //     console.error("Error updating admin:", error);
  //   }
  // };

  const handleSave = async () => {
    try {
      const values = await form.validateFields(); // ✅ get form values
     //console.log(values);

      // Convert radio value ("active" / "inactive") → boolean
      const updatedAdmin = {
        ...selectedAdmin,
        ...values,
        status: values.status === "active", // ✅ true if active, false if inactive
      };

      ////console.log("Saving:", updatedAdmin);

      if (!updatedAdmin?._id) return;

      const res = await fetch(`${process.env.REACT_APP_API_URL}/api/admin/update-admin`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(updatedAdmin),
      });

      const response = await res.json();
      ////console.log("Update Response:", response);

      if (response.isSuccess === true) {
        alert("Admin details updated successfully");

        if (response.info?._id) {
          setAdmins((prev) =>
            prev.map((admin) =>
              admin._id === response.info._id ? response.info : admin
            )
          );
        } else {
          console.warn("No _id in response.info, skipping state update");
        }

        setOpen(false);
      }
    } catch (error) {
      console.error("Error updating admin:", error);
    }
  };

  const fetchAdmins = async () => {
    try {
      const response = await getAllAdminApi();

      const eventAdmins = (response.data?.info || []).filter(
        (admin) => admin.category === "Events"
      );

      setAdmins(eventAdmins);
    } catch (error) {
      console.error("Error fetching admins:", error);
    }
  };

  useEffect(() => {
    fetchAdmins();
  }, []);

  return (
    <>
      <Card
        sx={{
          boxShadow: "none",
          borderRadius: "7px",
          mb: "25px",
          padding: { xs: "18px", sm: "20px", lg: "25px" },
        }}
        className="rmui-card"
      >
        {/* Search + Add New */}
        <Box
          sx={{
            display: { xs: "block", sm: "flex" },
            alignItems: "center",
            justifyContent: "space-between",
            mb: "25px",
          }}
        >
          <Box component="form" className="t-search-form" sx={{ width: { sm: "265px" } }}>
            <label>
              <i className="material-symbols-outlined">search</i>
            </label>
            <input
              type="text"
              className="t-input"
              placeholder="Search user here..."
              value={searchText}
              onChange={handleSearch}
            />
          </Box>
          <AddNewUser />
        </Box>

        {/* Table */}
        <Box sx={{ marginLeft: "-25px", marginRight: "-25px" }}>
          <TableContainer component={Paper} sx={{ boxShadow: "none", borderRadius: "0" }}>
            <Table sx={{ minWidth: 1350 }} aria-label="Table">
              <TableHead className="bg-primary-50">
                <TableRow
                  sx={{
                    th: { fontWeight: "500", padding: "10px 24px", fontSize: "14px" },
                  }}
                >
                  <TableCell>#</TableCell>
                  <TableCell>ID</TableCell>
                  <TableCell>User</TableCell>
                  <TableCell>Email</TableCell>
                  <TableCell>Role</TableCell>
                  <TableCell>Status</TableCell>
                  <TableCell>Action</TableCell>
                </TableRow>
              </TableHead>

              <TableBody>
                {(rowsPerPage > 0
                  ? admins.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  : admins
                ).map((admin) => (
                  <TableRow key={admin._id}>
                    <TableCell>
                      <Checkbox {...label} sx={{ padding: "8px" }} />
                    </TableCell>
                    <TableCell># {admin._id.slice(-4)}</TableCell>
                    <TableCell>
                      <Typography sx={{ fontSize: "15px", fontWeight: "500" }}>
                        {admin.firstName} {admin.lastName}
                      </Typography>
                    </TableCell>
                    <TableCell>{admin.emailId}</TableCell>
                    <TableCell>{admin.role || "N/A"}</TableCell>
                    <TableCell>
                      <Box
                        className={`trezo-badge ${admin.status ? "active" : "inactive"}`}
                        sx={{ textTransform: "capitalize" }}
                      >
                        {admin.status ? "Active" : "Pending"}
                      </Box>
                    </TableCell>
                    <TableCell>
                      <IconButton
                        aria-label="edit"
                        color="secondary"
                        sx={{ padding: "5px" }}
                        onClick={() => handleEditClick(admin)}
                      >
                        <i className="material-symbols-outlined" style={{ fontSize: "16px" }}>
                          edit
                        </i>
                      </IconButton>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>

              <TableFooter>
                <TableRow>
                  <TablePagination
                    rowsPerPageOptions={[5, 10, 25, { label: "All", value: -1 }]}
                    colSpan={10}
                    count={admins.length}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                    ActionsComponent={TablePaginationActions}
                  />
                </TableRow>
              </TableFooter>
            </Table>
          </TableContainer>
        </Box>
      </Card>

      {/* ✅ Antd Modal */}
      <Modal
        title="Edit Admin"
        open={open}
        onCancel={() => setOpen(false)}
        footer={[
          <Button key="cancel" onClick={() => setOpen(false)}>
            Cancel
          </Button>,
          <Button key="ok" type="primary" onClick={handleSave}>
            OK
          </Button>,
        ]}
      >
        <Form form={form} layout="vertical">
          <Form.Item
            label="First Name"
            name="firstName"
            rules={[{ required: true, message: "Please enter first name" }]}
          >
            <Input />
          </Form.Item>

          <Form.Item
            label="Last Name"
            name="lastName"
            rules={[{ required: true, message: "Please enter last name" }]}
          >
            <Input />
          </Form.Item>

          <Form.Item label="Email" name="emailId">
            <Input disabled />
          </Form.Item>

          <Form.Item label="Status" name="status">
            <Radio.Group>
              <Radio value="active">Active</Radio>
              <Radio value="inactive">Inactive</Radio>
            </Radio.Group>
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
};

export default UsersTable;

